/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/17
 * Copyright All Rights Reserved
 */

import React from 'react';
import SignInFormContainer from 'containers/forms/SignInFormContainer';
import SP3Logo from 'components/SP3Logo';
import Footer from 'components/Footer';
import MigrationBanner from 'components/MigrationBanner';

/**
 * Renders Sign In page
 * @return {Object}
 */
const SignInPage = () => (
  <div className="sign-in-page">
    <MigrationBanner />
    <div className="main-container-wrapper">
      <div className="container main-container">
        <div className="row">
          <div className="col col-sm-6 col-sm-push-6">
            <SP3Logo />
            <h1>Create your site hazards report today!</h1>
            <h2>Sign In</h2>
            <SignInFormContainer />
          </div>
          <div className="col col-sm-6 col-sm-pull-6">
            <ul>
              <li>Multiple Hazards from Hundreds of Studies</li>
              <li>Fast and Easy PDF Report</li>
              <li>Get Started Today!</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
);
export default SignInPage;
